<script setup lang="ts">
import { useAppStore } from "@/stores";

const appStore = useAppStore();
const locale = computed(() => appStore.locale);
</script>

<template>
  <el-config-provider :locale="locale">
    <RouterView />
  </el-config-provider>
</template>

<style scoped></style>
